import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { setAlert } from '../../../actions/alert';
import { obtenerOrden, editarOrden, limpiarDetalleOrden } from '../../../actions/ordenesSalida';
import {
    buscarCategoriasConfiguracion,
    buscarSubcategoriasConfiguracion,
    buscarProductosConfiguracion,
    limpiarProductosConfiguracion,
    buscarUnidades,
    buscarProveedoresProducto,
    limpiarProveedoresProducto,
    buscarPaquetes,
    limpiarPaquetes
} from '../../../actions/configuracion';
import SeleccionPaqueteOrdenModal from './modals/SeleccionPaqueteOrdenModal';

const opcionesTipoConcepto = [
    { value: 1, label: 'Producto' },
    { value: 2, label: 'Servicio' }
];

const formatMoney = (n) => {
    const v = Number(n || 0);
    return `$${new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v)}`;
};

const formatYYYYMMDD = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return null;
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const parseFecha = (value) => {
    if (!value) return new Date();
    const d = new Date(value);
    return isNaN(d.getTime()) ? new Date() : d;
};

const EditarOrdenSalida = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const { detalle: orden, loadingDetalle } = useSelector(state => state.ordenesSalida);
    const { listado: listado_categorias } = useSelector(state => state.configuracion.categorias);
    const { listado: listado_subcategorias } = useSelector(state => state.configuracion.subcategorias);
    const { listado: listado_productos } = useSelector(state => state.configuracion.productos);
    const { listado: listado_proveedores_producto } = useSelector(state => state.configuracion.proveedores_producto);
    const { listado: listado_unidades } = useSelector(state => state.configuracion.unidades);
    const { listado: paquetesBusqueda } = useSelector(state => state.configuracion?.paquetes || { listado: [] });

    const [fecha, setFecha] = useState(new Date());

    const [categoriaSel, setCategoriaSel] = useState(null);
    const [subcategoriaSel, setSubcategoriaSel] = useState(null);
    const [codigoTienda, setCodigoTienda] = useState('');
    const [codigoProveedor, setCodigoProveedor] = useState('');
    const [nombreBusqueda, setNombreBusqueda] = useState('');
    const [productoSel, setProductoSel] = useState(null);
    const [proveedorSel, setProveedorSel] = useState(null);
    const [unidadProductoSel, setUnidadProductoSel] = useState(null);
    const [cantidadProducto, setCantidadProducto] = useState('');
    const [precioCompraProducto, setPrecioCompraProducto] = useState('');
    const [precioVentaProducto, setPrecioVentaProducto] = useState('');
    const [precioProducto, setPrecioProducto] = useState('');
    const [ivaProducto, setIvaProducto] = useState(false);

    const [productos, setProductos] = useState([]);

    const [tipoConceptoSel, setTipoConceptoSel] = useState(null);
    const [detalleConcepto, setDetalleConcepto] = useState('');
    const [cantidadConcepto, setCantidadConcepto] = useState('');
    const [unidadConceptoSel, setUnidadConceptoSel] = useState(null);
    const [precioUnitarioConcepto, setPrecioUnitarioConcepto] = useState('');
    const [ivaConcepto, setIvaConcepto] = useState(false);

    const [conceptos, setConceptos] = useState([]);

    const [busquedaPaquete, setBusquedaPaquete] = useState('');
    const [buscandoPaquetes, setBuscandoPaquetes] = useState(false);
    const [showSeleccionPaquete, setShowSeleccionPaquete] = useState(false);
    const [paqueteActual, setPaqueteActual] = useState(null);
    const [paquetes, setPaquetes] = useState([]);
    const [paquetesExpandidos, setPaquetesExpandidos] = useState({});

    const [guardando, setGuardando] = useState(false);
    const [cargaInicial, setCargaInicial] = useState(false);

    const productoTimerRef = useRef(null);
    const paqueteTimerRef = useRef(null);

    useEffect(() => {
        if (!id) return;

        dispatch(obtenerOrden(id));
        dispatch(buscarCategoriasConfiguracion());
        dispatch(buscarUnidades());

        return () => {
            dispatch(limpiarDetalleOrden());
            dispatch(limpiarProveedoresProducto());
            dispatch(limpiarProductosConfiguracion());
            dispatch(limpiarPaquetes());
        };
    }, [dispatch, id]);

    useEffect(() => {
        const q = (busquedaPaquete || '').trim();

        if (!q) {
            dispatch(limpiarPaquetes());
            setBuscandoPaquetes(false);
            return;
        }

        if (paqueteTimerRef.current) {
            clearTimeout(paqueteTimerRef.current);
        }

        setBuscandoPaquetes(true);

        paqueteTimerRef.current = setTimeout(async () => {
            await dispatch(buscarPaquetes({ busqueda: q }));
            setBuscandoPaquetes(false);
        }, 350);

        return () => {
            if (paqueteTimerRef.current) {
                clearTimeout(paqueteTimerRef.current);
            }
        };
    }, [busquedaPaquete, dispatch]);

    useEffect(() => {
        const idCat = categoriaSel?.value || null;
        const idSub = subcategoriaSel?.value || null;
        const ct = (codigoTienda || '').trim();
        const cp = (codigoProveedor || '').trim();
        const n = (nombreBusqueda || '').trim();

        const hayFiltro = !!(idCat || idSub || ct || cp || n);

        if (!hayFiltro) {
            dispatch(limpiarProductosConfiguracion());
            return;
        }

        if (productoTimerRef.current) {
            clearTimeout(productoTimerRef.current);
        }

        productoTimerRef.current = setTimeout(() => {
            dispatch(buscarProductosConfiguracion({
                id_categoria: idCat,
                id_subcategoria: idSub,
                nombre: n || null,
                codigo: ct || null,
                codigo_proveedor: cp || null
            }));
        }, 350);

        return () => {
            if (productoTimerRef.current) {
                clearTimeout(productoTimerRef.current);
            }
        };
    }, [categoriaSel, subcategoriaSel, codigoTienda, codigoProveedor, nombreBusqueda, dispatch]);

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: false, nombre: 'Proyectos', path: '/proyectos' },
            { activo: false, nombre: orden?.proyecto?.nombre || 'Proyecto', path: `/proyectos/detalle/${orden?.proyecto?._id || ''}` },
            { activo: true, nombre: `Editar orden ${orden?.folio || ''}`.trim(), path: `/proyectos/ordenes/editar/${id}` }
        ]));
    }, [dispatch, id, orden]);

    useEffect(() => {
        if (!orden || cargaInicial) return;

        if (orden.status === 3 || orden.status === 4) {
            dispatch(setAlert('No se puede editar una orden cancelada o eliminada', 'danger'));
            navigate(`/proyectos/detalle/${orden?.proyecto?._id || ''}`);
            return;
        }

        setFecha(parseFecha(orden.fecha));

        setProductos((orden.productos || []).map((p) => ({
            key: p._id,
            producto: p.producto?._id || null,
            productoNombre: p.producto?.nombre || 'Sin definir',
            proveedor: p.proveedor?._id || null,
            proveedorNombre: p.proveedor?.nombre || null,
            unidad: p.unidad?._id || null,
            unidadNombre: p.unidad?.nombre || null,
            cantidad: Number(p.cantidad || 0),
            precio_compra: Number(p.precio_compra || 0),
            precio_venta: Number(p.precio_venta || 0),
            precio: Number(p.precio || 0),
            conversion: Number(p.conversion || 1),
            iva: !!p.iva
        })));

        setConceptos((orden.conceptos || []).map((c) => ({
            key: c._id,
            tipo: Number(c.tipo),
            detalle: c.detalle || '',
            cantidad: Number(c.cantidad || 0),
            unidad: c.unidad?._id || null,
            unidadNombre: c.unidad?.nombre || null,
            precio_unitario: Number(c.precio_unitario || 0),
            iva: !!c.iva
        })));

        setPaquetes((orden.paquetes || []).map((p) => ({
            key: p._id,
            paqueteId: p.paquete?._id || null,
            paqueteNombre: p.paquete?.nombre || 'Sin definir',
            paqueteCodigo: p.paquete?.codigo || null,
            cantidad: Number(p.cantidad || 0),
            precio: Number(p.precio || 0),
            iva: !!p.iva,
            componentes: (Array.isArray(p.componentes) ? p.componentes : []).map((c) => ({
                productoId: c._id,
                productoNombre: c.nombre || '',
                unidadNombre: c.unidad?.nombre || '',
                cantidadPorPaquete: Number(c.cantidad_nominal ?? c.cantidad ?? 0),
                conversion: Number(c.conversion || 1) || 1
            }))
        })));

        setCargaInicial(true);
    }, [orden, cargaInicial, dispatch, navigate]);

    const opcionesCategorias = useMemo(() => {
        return (listado_categorias || []).map(c => ({ value: c._id, label: c.nombre }));
    }, [listado_categorias]);

    const opcionesSubcategorias = useMemo(() => {
        return (listado_subcategorias || []).map(s => ({ value: s._id, label: s.nombre }));
    }, [listado_subcategorias]);

    const opcionesProductos = useMemo(() => {
        return (listado_productos || []).map(p => ({ value: p._id, label: p.nombre, raw: p }));
    }, [listado_productos]);

    const algunFiltroProducto = !!(
        categoriaSel?.value ||
        subcategoriaSel?.value ||
        (codigoTienda || '').trim() ||
        (codigoProveedor || '').trim() ||
        (nombreBusqueda || '').trim()
    );

    const opcionesProveedores = useMemo(() => {
        return (listado_proveedores_producto || [])
            .filter(pp => pp?.proveedor?._id)
            .map(pp => ({ value: pp.proveedor._id, label: pp.proveedor.nombre }));
    }, [listado_proveedores_producto]);

    const opcionesUnidadesConcepto = useMemo(() => {
        return (listado_unidades || []).map(u => ({ value: u._id, label: u.nombre }));
    }, [listado_unidades]);

    const paquetesOptions = useMemo(() => {
        return (Array.isArray(paquetesBusqueda) ? paquetesBusqueda : []).map((p) => ({
            value: p._id,
            label: `${p.nombre}${p.codigo ? ` (${p.codigo})` : ''}`,
            raw: p
        }));
    }, [paquetesBusqueda]);

    const opcionesUnidadesProducto = useMemo(() => {
        const unidades = Array.isArray(productoSel?.raw?.unidades) ? productoSel.raw.unidades : [];
        const deVenta = unidades.filter(u => Number(u?.tipo) === 3);
        const disponibles = deVenta.length > 0 ? deVenta : unidades;

        return disponibles
            .filter(u => u?.unidad?._id)
            .map(u => ({ value: u.unidad._id, label: u.unidad.nombre }));
    }, [productoSel]);

    const onChangeCategoria = (opt) => {
        setCategoriaSel(opt || null);
        setSubcategoriaSel(null);

        if (opt?.value) {
            dispatch(buscarSubcategoriasConfiguracion(opt.value));
        }
    };

    const onChangeSubcategoria = (opt) => {
        setSubcategoriaSel(opt || null);
    };

    const onChangeProducto = (opt) => {
        setProductoSel(opt || null);
        setUnidadProductoSel(null);
        setProveedorSel(null);
        setPrecioCompraProducto('');
        setPrecioVentaProducto('');
        setPrecioProducto('');

        if (opt?.value) {
            dispatch(buscarProveedoresProducto(opt.value));
        } else {
            dispatch(limpiarProveedoresProducto());
        }
    };

    const onChangeProveedor = (opt) => {
        setProveedorSel(opt || null);

        const match = (listado_proveedores_producto || []).find(pp => pp?.proveedor?._id === opt?.value);
        const compra = match?.precio_historico || 0;
        const venta = match?.precio_publico || 0;

        setPrecioCompraProducto(opt ? compra : '');
        setPrecioVentaProducto(opt ? venta : '');

        setPrecioProducto((prev) => {
            if (!opt) return '';
            return (prev === '' || prev === null || Number(prev) === 0) ? venta : prev;
        });
    };

    const limpiarFormularioProducto = () => {
        setProductoSel(null);
        setProveedorSel(null);
        setUnidadProductoSel(null);
        setCantidadProducto('');
        setPrecioCompraProducto('');
        setPrecioVentaProducto('');
        setPrecioProducto('');
        setIvaProducto(false);
        dispatch(limpiarProveedoresProducto());
    };

    const puedeAgregarProducto = useMemo(() => {
        return Boolean(productoSel?.value && Number(cantidadProducto) > 0 && Number(precioProducto || 0) >= 0);
    }, [productoSel, cantidadProducto, precioProducto]);

    const onAgregarProducto = () => {
        if (!puedeAgregarProducto) return;

        setProductos((prev) => {
            const idx = prev.findIndex(p => p.producto === productoSel.value);

            const datosActuales = {
                producto: productoSel.value,
                productoNombre: productoSel.label,
                proveedor: proveedorSel?.value || null,
                proveedorNombre: proveedorSel?.label || null,
                unidad: unidadProductoSel?.value || null,
                unidadNombre: unidadProductoSel?.label || null,
                precio_compra: Number(precioCompraProducto || 0),
                precio_venta: Number(precioVentaProducto || 0),
                precio: Number(precioProducto || 0),
                conversion: 1,
                iva: ivaProducto
            };

            if (idx === -1) {
                return [
                    ...prev,
                    {
                        key: `${productoSel.value}-${Date.now()}`,
                        cantidad: Number(cantidadProducto),
                        ...datosActuales
                    }
                ];
            }

            const copy = [...prev];
            copy[idx] = {
                ...copy[idx],
                ...datosActuales,
                cantidad: Number(copy[idx].cantidad || 0) + Number(cantidadProducto)
            };
            return copy;
        });

        limpiarFormularioProducto();
    };

    const onEliminarProducto = (key) => {
        setProductos((prev) => prev.filter(p => p.key !== key));
    };

    const onChangeCantidadFila = (key, value) => {
        const cantidad = value === '' ? '' : Number(value);
        setProductos((prev) => prev.map(p => p.key === key ? { ...p, cantidad } : p));
    };

    const onChangePrecioFila = (key, value) => {
        const precio = value === undefined || value === null || value === '' ? '' : Number(value);
        setProductos((prev) => prev.map(p => p.key === key ? { ...p, precio } : p));
    };

    const onChangeIvaFila = (key) => {
        setProductos((prev) => prev.map(p => p.key === key ? { ...p, iva: !p.iva } : p));
    };

    const limpiarFormularioConcepto = () => {
        setTipoConceptoSel(null);
        setDetalleConcepto('');
        setCantidadConcepto('');
        setUnidadConceptoSel(null);
        setPrecioUnitarioConcepto('');
        setIvaConcepto(false);
    };

    const unidadConceptoRequerida = tipoConceptoSel?.value !== 2;

    const puedeAgregarConcepto = useMemo(() => {
        return Boolean(
            tipoConceptoSel?.value &&
            detalleConcepto.trim().length > 0 &&
            Number(cantidadConcepto) > 0 &&
            (!unidadConceptoRequerida || unidadConceptoSel?.value)
        );
    }, [tipoConceptoSel, detalleConcepto, cantidadConcepto, unidadConceptoSel, unidadConceptoRequerida]);

    const onAgregarConcepto = () => {
        if (!puedeAgregarConcepto) return;

        setConceptos((prev) => ([
            ...prev,
            {
                key: `concepto-${Date.now()}`,
                tipo: tipoConceptoSel.value,
                detalle: detalleConcepto.trim(),
                cantidad: Number(cantidadConcepto),
                unidad: unidadConceptoSel?.value || null,
                unidadNombre: unidadConceptoSel?.label || null,
                precio_unitario: Number(precioUnitarioConcepto || 0),
                iva: ivaConcepto
            }
        ]));

        limpiarFormularioConcepto();
    };

    const onEliminarConcepto = (key) => {
        setConceptos((prev) => prev.filter(c => c.key !== key));
    };

    const onChangePrecioUnitarioConceptoFila = (key, value) => {
        const precio = value === undefined || value === null || value === '' ? '' : Number(value);
        setConceptos((prev) => prev.map(c => c.key === key ? { ...c, precio_unitario: precio } : c));
    };

    const onChangeIvaConceptoFila = (key) => {
        setConceptos((prev) => prev.map(c => c.key === key ? { ...c, iva: !c.iva } : c));
    };

    const onSelectPaquete = (opt) => {
        if (!opt?.raw) return;
        setPaqueteActual(opt.raw);
        setShowSeleccionPaquete(true);
    };

    const onConfirmPaquete = (data) => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);

        setPaquetes((prev) => ([
            ...prev,
            { key: `${data.paqueteId}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, ...data }
        ]));
    };

    const cerrarSeleccionPaquete = () => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);
    };

    const togglePaqueteExpandido = (key) => {
        setPaquetesExpandidos((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const onEliminarPaquete = (key) => {
        setPaquetes((prev) => prev.filter(p => p.key !== key));
    };

    const onChangeCantidadPaquete = (key, value) => {
        const cantidad = value === '' ? '' : Number(value);
        setPaquetes((prev) => prev.map(p => p.key === key ? { ...p, cantidad } : p));
    };

    const onChangePrecioPaquete = (key, value) => {
        const precio = value === undefined || value === null || value === '' ? '' : Number(value);
        setPaquetes((prev) => prev.map(p => p.key === key ? { ...p, precio } : p));
    };

    const onChangeIvaPaquete = (key) => {
        setPaquetes((prev) => prev.map(p => p.key === key ? { ...p, iva: !p.iva } : p));
    };

    const totalProductos = useMemo(() => {
        return productos.reduce((acc, p) => {
            const base = Number(p.cantidad || 0) * Number(p.precio || 0);
            return acc + (p.iva ? base * 1.16 : base);
        }, 0);
    }, [productos]);

    const totalConceptos = useMemo(() => {
        return conceptos.reduce((acc, c) => {
            const base = Number(c.cantidad || 0) * Number(c.precio_unitario || 0);
            return acc + (c.iva ? base * 1.16 : base);
        }, 0);
    }, [conceptos]);

    const totalPaquetes = useMemo(() => {
        return paquetes.reduce((acc, p) => {
            const base = Number(p.cantidad || 0) * Number(p.precio || 0);
            return acc + (p.iva ? base * 1.16 : base);
        }, 0);
    }, [paquetes]);

    const total = totalProductos + totalConceptos + totalPaquetes;

    const puedeGuardar = useMemo(() => {
        return Boolean(id && (productos.length > 0 || conceptos.length > 0 || paquetes.length > 0) && !guardando);
    }, [id, productos, conceptos, paquetes, guardando]);

    const onGuardar = async () => {
        if (!puedeGuardar) return;

        if (productos.length === 0 && conceptos.length === 0 && paquetes.length === 0) {
            dispatch(setAlert('Agrega al menos un producto, concepto o paquete', 'danger'));
            return;
        }

        setGuardando(true);
        const resultado = await dispatch(editarOrden({
            id,
            fecha: formatYYYYMMDD(fecha),
            total,
            productos: productos.map(p => ({
                _id: soloPrecios ? p.key : undefined,
                producto: p.producto,
                unidad: p.unidad,
                proveedor: p.proveedor,
                cantidad: p.cantidad,
                precio_compra: p.precio_compra,
                precio_venta: p.precio_venta,
                precio: p.precio,
                conversion: p.conversion,
                iva: p.iva
            })),
            conceptos: conceptos.map(c => ({
                _id: soloPrecios ? c.key : undefined,
                tipo: c.tipo,
                detalle: c.detalle,
                cantidad: c.cantidad,
                unidad: c.unidad,
                precio_unitario: c.precio_unitario,
                iva: c.iva
            })),
            paquetes: paquetes.map(p => ({
                _id: soloPrecios ? p.key : undefined,
                paquete: p.paqueteId,
                cantidad: p.cantidad,
                precio: p.precio,
                iva: p.iva
            }))
        }));
        setGuardando(false);

        if (!resultado) return;

        navigate(`/proyectos/detalle/${orden?.proyecto?._id || ''}`);
    };

    const statusOrden = Number(orden?.status);
    /* status 1/2 (ya entregada total o parcialmente): el backend solo acepta ajustar precio/IVA
       de los renglones existentes — no agregar, quitar ni cambiar cantidades. */
    const soloPrecios = statusOrden === 1 || statusOrden === 2;

    if (loadingDetalle || !orden) {
        return (
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Cargando orden de salida...</h3>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5 mb-1">{soloPrecios ? 'Editar precios de la orden de salida' : 'Editar orden de salida'}</h3>
                    <h6 className="text-muted mb-4">{orden?.folio || ''} · {orden?.proyecto?.nombre || 'Proyecto'}</h6>

                    {soloPrecios && (
                        <div className="alert alert-info">
                            Esta orden ya tiene entregas registradas — solo puedes ajustar el precio y el IVA de los productos,
                            paquetes y conceptos existentes. No se pueden agregar, quitar artículos ni cambiar cantidades o fecha.
                        </div>
                    )}

                    <div className="mb-4" style={{ maxWidth: 240 }}>
                        <div className="text-muted small mb-1">Fecha</div>
                        <DatePicker
                            selected={fecha}
                            onChange={(d) => setFecha(d)}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            disabled={soloPrecios}
                        />
                    </div>

                    <h5 className="mb-3">Productos</h5>

                    {!soloPrecios && (
                    <div className="row g-3 mb-3">
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Categoría</div>
                            <Select
                                options={opcionesCategorias}
                                value={categoriaSel}
                                onChange={onChangeCategoria}
                                isClearable
                                placeholder="Categoría..."
                                noOptionsMessage={() => 'Sin resultados'}
                            />
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Subcategoría</div>
                            <Select
                                options={opcionesSubcategorias}
                                value={subcategoriaSel}
                                onChange={onChangeSubcategoria}
                                isClearable
                                isDisabled={!categoriaSel}
                                placeholder="Subcategoría..."
                                noOptionsMessage={() => 'Sin resultados'}
                            />
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Código tienda</div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Código tienda"
                                value={codigoTienda}
                                onChange={(e) => setCodigoTienda(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Código proveedor</div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Código proveedor"
                                value={codigoProveedor}
                                onChange={(e) => setCodigoProveedor(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <div className="text-muted small mb-1">Nombre del producto</div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre del producto"
                                value={nombreBusqueda}
                                onChange={(e) => setNombreBusqueda(e.target.value)}
                            />
                        </div>

                        <div className="col-md-6">
                            <div className="text-muted small mb-1">Producto</div>
                            <Select
                                options={opcionesProductos}
                                value={productoSel}
                                onChange={onChangeProducto}
                                isClearable
                                placeholder="Producto..."
                                noOptionsMessage={() => (algunFiltroProducto ? 'Sin resultados' : 'Aplica un filtro para buscar')}
                            />
                        </div>

                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Proveedor (opcional)</div>
                            <Select
                                options={opcionesProveedores}
                                value={proveedorSel}
                                onChange={onChangeProveedor}
                                isClearable
                                isDisabled={!productoSel}
                                placeholder="Proveedor (opcional)..."
                                noOptionsMessage={() => 'Sin resultados'}
                            />
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Unidad</div>
                            <Select
                                options={opcionesUnidadesProducto}
                                value={unidadProductoSel}
                                onChange={setUnidadProductoSel}
                                isClearable
                                isDisabled={!productoSel}
                                placeholder="Unidad..."
                                noOptionsMessage={() => 'Sin unidades'}
                            />
                        </div>
                        <div className="col-md-2">
                            <div className="text-muted small mb-1">Cantidad</div>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Cantidad"
                                value={cantidadProducto}
                                onChange={(e) => setCantidadProducto(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-center">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="iva_producto"
                                    checked={ivaProducto}
                                    onChange={(e) => setIvaProducto(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="iva_producto">IVA</label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="text-muted small mb-1">Precio compra</div>
                            <CurrencyInput
                                value={precioCompraProducto}
                                decimalsLimit={3}
                                allowNegativeValue={false}
                                placeholder="$ Precio compra"
                                className="form-control"
                                prefix="$ "
                                groupSeparator=","
                                decimalSeparator="."
                                disabled
                                onValueChange={() => {}}
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="text-muted small mb-1">Precio venta</div>
                            <CurrencyInput
                                value={precioVentaProducto}
                                decimalsLimit={3}
                                allowNegativeValue={false}
                                placeholder="$ Precio venta"
                                className="form-control"
                                prefix="$ "
                                groupSeparator=","
                                decimalSeparator="."
                                disabled
                                onValueChange={() => {}}
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="text-muted small mb-1">Precio final</div>
                            <CurrencyInput
                                value={precioProducto}
                                decimalsLimit={3}
                                allowNegativeValue={false}
                                placeholder="$ Precio final"
                                className="form-control"
                                prefix="$ "
                                groupSeparator=","
                                decimalSeparator="."
                                onValueChange={(value) => setPrecioProducto(value || '')}
                            />
                        </div>

                        <div className="col-12 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={onAgregarProducto}
                                disabled={!puedeAgregarProducto}
                            >
                                <i className="feather icon-plus" /> Agregar producto
                            </button>
                        </div>
                    </div>
                    )}

                    <div className="table-responsive mb-4">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Proveedor</th>
                                    <th>Unidad</th>
                                    <th className="text-end">Cantidad</th>
                                    <th className="text-end">Precio compra</th>
                                    <th className="text-end">Precio venta</th>
                                    <th className="text-end">Precio final</th>
                                    <th className="text-center">IVA</th>
                                    <th className="text-end">Importe</th>
                                    <th className="text-end">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productos.length === 0 && (
                                    <tr>
                                        <td colSpan="10" className="text-center text-muted">
                                            Sin productos agregados
                                        </td>
                                    </tr>
                                )}

                                {productos.map((p) => {
                                    const importe = Number(p.cantidad || 0) * Number(p.precio || 0) * (p.iva ? 1.16 : 1);
                                    return (
                                        <tr key={p.key}>
                                            <td>{p.productoNombre}</td>
                                            <td>{p.proveedorNombre || '—'}</td>
                                            <td>{p.unidadNombre || '—'}</td>
                                            <td className="text-end" style={{ minWidth: 110 }}>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm text-end"
                                                    value={p.cantidad}
                                                    onChange={(e) => onChangeCantidadFila(p.key, e.target.value)}
                                                    disabled={soloPrecios}
                                                />
                                            </td>
                                            <td className="text-end">{formatMoney(p.precio_compra)}</td>
                                            <td className="text-end">{formatMoney(p.precio_venta)}</td>
                                            <td className="text-end" style={{ minWidth: 150 }}>
                                                <CurrencyInput
                                                    value={p.precio}
                                                    decimalsLimit={3}
                                                    allowNegativeValue={false}
                                                    className="form-control form-control-sm text-end"
                                                    prefix="$ "
                                                    groupSeparator=","
                                                    decimalSeparator="."
                                                    onValueChange={(value) => onChangePrecioFila(p.key, value)}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={!!p.iva}
                                                    onChange={() => onChangeIvaFila(p.key)}
                                                />
                                            </td>
                                            <td className="text-end">{formatMoney(importe)}</td>
                                            <td className="text-end">
                                                {!soloPrecios && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-link px-2"
                                                        title="Eliminar"
                                                        onClick={() => onEliminarProducto(p.key)}
                                                    >
                                                        <i className="fas fa-trash text-danger" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <h5 className="mb-3">Conceptos</h5>

                    {!soloPrecios && (
                    <div className="row g-3 mb-3">
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Tipo</div>
                            <Select
                                options={opcionesTipoConcepto}
                                value={tipoConceptoSel}
                                onChange={setTipoConceptoSel}
                                placeholder="Tipo..."
                                noOptionsMessage={() => 'Sin resultados'}
                            />
                        </div>
                        <div className="col-md-9">
                            <div className="text-muted small mb-1">Detalle</div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Detalle"
                                value={detalleConcepto}
                                onChange={(e) => setDetalleConcepto(e.target.value)}
                            />
                        </div>

                        <div className="col-md-3">
                            <div className="text-muted small mb-1">Cantidad</div>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Cantidad"
                                value={cantidadConcepto}
                                onChange={(e) => setCantidadConcepto(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small mb-1">{unidadConceptoRequerida ? 'Unidad' : 'Unidad (opcional)'}</div>
                            <Select
                                options={opcionesUnidadesConcepto}
                                value={unidadConceptoSel}
                                onChange={setUnidadConceptoSel}
                                isClearable={!unidadConceptoRequerida}
                                placeholder={unidadConceptoRequerida ? 'Unidad...' : 'Unidad (opcional)...'}
                                noOptionsMessage={() => 'Sin resultados'}
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="text-muted small mb-1">Precio unitario</div>
                            <CurrencyInput
                                value={precioUnitarioConcepto}
                                decimalsLimit={3}
                                allowNegativeValue={false}
                                placeholder="$ Precio unitario"
                                className="form-control"
                                prefix="$ "
                                groupSeparator=","
                                decimalSeparator="."
                                onValueChange={(value) => setPrecioUnitarioConcepto(value || '')}
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-center">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="editar-orden-concepto-iva"
                                    checked={ivaConcepto}
                                    onChange={(e) => setIvaConcepto(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="editar-orden-concepto-iva">IVA</label>
                            </div>
                        </div>

                        <div className="col-12 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={onAgregarConcepto}
                                disabled={!puedeAgregarConcepto}
                            >
                                <i className="feather icon-plus" /> Agregar concepto
                            </button>
                        </div>
                    </div>
                    )}

                    <div className="table-responsive mb-4">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Tipo</th>
                                    <th>Detalle</th>
                                    <th className="text-end">Cantidad</th>
                                    <th>Unidad</th>
                                    <th className="text-end">Precio unitario</th>
                                    <th className="text-center">IVA</th>
                                    <th className="text-end">Importe</th>
                                    <th className="text-end">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {conceptos.length === 0 && (
                                    <tr>
                                        <td colSpan="8" className="text-center text-muted">
                                            Sin conceptos agregados
                                        </td>
                                    </tr>
                                )}

                                {conceptos.map((c) => {
                                    const base = Number(c.cantidad || 0) * Number(c.precio_unitario || 0);
                                    const importe = c.iva ? base * 1.16 : base;
                                    return (
                                        <tr key={c.key}>
                                            <td>{c.tipo === 1 ? 'Producto' : 'Servicio'}</td>
                                            <td>{c.detalle}</td>
                                            <td className="text-end">{c.cantidad}</td>
                                            <td>{c.unidadNombre || '—'}</td>
                                            <td className="text-end" style={{ minWidth: 150 }}>
                                                <CurrencyInput
                                                    value={c.precio_unitario}
                                                    decimalsLimit={3}
                                                    allowNegativeValue={false}
                                                    className="form-control form-control-sm text-end"
                                                    prefix="$ "
                                                    groupSeparator=","
                                                    decimalSeparator="."
                                                    onValueChange={(value) => onChangePrecioUnitarioConceptoFila(c.key, value)}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={!!c.iva}
                                                    onChange={() => onChangeIvaConceptoFila(c.key)}
                                                />
                                            </td>
                                            <td className="text-end">{formatMoney(importe)}</td>
                                            <td className="text-end">
                                                {!soloPrecios && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-link px-2"
                                                        title="Eliminar"
                                                        onClick={() => onEliminarConcepto(c.key)}
                                                    >
                                                        <i className="fas fa-trash text-danger" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <h5 className="mb-3">Paquetes</h5>

                    {!soloPrecios && (
                    <div className="row g-3 mb-3 align-items-end">
                        <div className="col-md-6">
                            <div className="text-muted small mb-1">Nombre o código</div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre o código del paquete"
                                value={busquedaPaquete}
                                onChange={(e) => setBusquedaPaquete(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <div className="text-muted small mb-1">Paquete</div>
                            <Select
                                placeholder="Selecciona un paquete de los resultados..."
                                value={null}
                                onChange={onSelectPaquete}
                                options={paquetesOptions}
                                isLoading={buscandoPaquetes}
                                noOptionsMessage={() =>
                                    buscandoPaquetes
                                        ? 'Buscando...'
                                        : ((busquedaPaquete || '').trim() ? 'Sin resultados' : 'Escribe para buscar')
                                }
                            />
                        </div>
                    </div>
                    )}

                    <div className="table-responsive mb-4">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th style={{ width: 30 }} />
                                    <th>Paquete</th>
                                    <th className="text-end">Cantidad</th>
                                    <th className="text-end">Precio final</th>
                                    <th className="text-center">IVA</th>
                                    <th className="text-end">Importe</th>
                                    <th className="text-end">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paquetes.length === 0 && (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted">
                                            Sin paquetes agregados
                                        </td>
                                    </tr>
                                )}

                                {paquetes.map((p) => {
                                    const cantidad = Number(p.cantidad || 0);
                                    const importe = cantidad * Number(p.precio || 0) * (p.iva ? 1.16 : 1);
                                    const componentes = Array.isArray(p.componentes) ? p.componentes : [];
                                    const abierto = !!paquetesExpandidos[p.key];

                                    return (
                                        <Fragment key={p.key}>
                                            <tr>
                                                <td className="text-center align-middle">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-link p-0"
                                                        onClick={() => togglePaqueteExpandido(p.key)}
                                                        title={abierto ? 'Ocultar productos del paquete' : 'Ver productos del paquete'}
                                                    >
                                                        <i className={`fas fa-chevron-${abierto ? 'down' : 'right'}`} />
                                                    </button>
                                                </td>
                                                <td className="align-middle">
                                                    <div className="fw-semibold">{p.paqueteNombre}</div>
                                                    {p.paqueteCodigo ? (
                                                        <div className="text-muted" style={{ fontSize: 12 }}>{p.paqueteCodigo}</div>
                                                    ) : null}
                                                </td>
                                                <td className="text-end" style={{ minWidth: 110 }}>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm text-end"
                                                        value={p.cantidad}
                                                        min="1"
                                                        onChange={(e) => onChangeCantidadPaquete(p.key, e.target.value)}
                                                        disabled={soloPrecios}
                                                    />
                                                </td>
                                                <td className="text-end" style={{ minWidth: 150 }}>
                                                    <CurrencyInput
                                                        value={p.precio}
                                                        decimalsLimit={3}
                                                        allowNegativeValue={false}
                                                        className="form-control form-control-sm text-end"
                                                        prefix="$ "
                                                        groupSeparator=","
                                                        decimalSeparator="."
                                                        onValueChange={(value) => onChangePrecioPaquete(p.key, value)}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={!!p.iva}
                                                        onChange={() => onChangeIvaPaquete(p.key)}
                                                    />
                                                </td>
                                                <td className="text-end">{formatMoney(importe)}</td>
                                                <td className="text-end">
                                                    {!soloPrecios && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-link px-2"
                                                        title="Eliminar"
                                                        onClick={() => onEliminarPaquete(p.key)}
                                                    >
                                                        <i className="fas fa-trash text-danger" />
                                                    </button>
                                                    )}
                                                </td>
                                            </tr>
                                            {abierto && (
                                                <tr>
                                                    <td />
                                                    <td colSpan={6} className="p-0">
                                                        <div className="table-responsive m-2">
                                                            <table className="table table-sm mb-0" style={{ fontSize: 13 }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Producto</th>
                                                                        <th className="text-center" style={{ width: 130 }}>Cantidad</th>
                                                                        <th style={{ width: 150 }}>Unidad</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {componentes.length === 0 ? (
                                                                        <tr>
                                                                            <td colSpan={3} className="text-muted text-center">Sin productos</td>
                                                                        </tr>
                                                                    ) : componentes.map((c) => {
                                                                        const conversion = Number(c?.conversion || 1) || 1;
                                                                        const necesaria = (Number(c?.cantidadPorPaquete || 0) * cantidad) / conversion;

                                                                        return (
                                                                            <tr key={c.productoId}>
                                                                                <td>{c.productoNombre}</td>
                                                                                <td className="text-center">{necesaria}</td>
                                                                                <td>{c.unidadNombre || '-'}</td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div className="fs-5">
                            <span className="text-muted">Total: </span>
                            <span className="fw-bold">{formatMoney(total)}</span>
                        </div>

                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate(`/proyectos/detalle/${orden?.proyecto?._id || ''}`)}
                                disabled={guardando}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={onGuardar}
                                disabled={!puedeGuardar}
                            >
                                Guardar cambios
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <SeleccionPaqueteOrdenModal
                show={showSeleccionPaquete}
                onHide={cerrarSeleccionPaquete}
                onConfirm={onConfirmPaquete}
                paquete={paqueteActual}
            />
        </Fragment>
    );
};

export default EditarOrdenSalida;
